"use strict";

require("core-js/modules/es.weak-map.js");
require("core-js/modules/esnext.iterator.constructor.js");
require("core-js/modules/esnext.iterator.filter.js");
require("core-js/modules/esnext.iterator.for-each.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("core-js/modules/esnext.iterator.map.js");
require("core-js/modules/web.dom-collections.iterator.js");
var _react = _interopRequireWildcard(require("react"));
var _chevronRight = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron-right.svg"));
var _chevronLeft = _interopRequireDefault(require("@svb/svbbranding/dist/assets/icons/chevron-left.svg"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); } /**
 * Pagination component
 * By Prashant Bhatt<pbhatt@svb.com> (www.svb.com)
 * Summary
 * This component renders pagination that returns offset and limit for parent component to use
 */
/**
 * PaginationComponent
 * @param { totalItems, paginateTitle, paginationStatesVal, paginationStatesSetter,
 * nextBtnDisable, prevBtnDisable, rowsPerPageLists, extraClasses, overrideElementClass }
 * check readme for prop detail
 * @returns
 */
const SVBPaginator = props => {
  const {
    paginateTitle = 'Rows per page:',
    totalItems = 0,
    paginationStatesVal,
    paginationStatesSetter,
    nextBtnDisable,
    prevBtnDisable,
    rowsPerPageLists = [10, 20, 30, 50],
    extraClasses = '',
    overrideElementClass = ''
  } = props;
  const finalClasses = overrideElementClass ? overrideElementClass : "d-flex flex-row align-items-center mw-align-paginate ".concat(extraClasses);

  //setting min default prop in case of no state variables passed from parent,
  //so that component always has default value
  const defaultPaginationProps = {
    currentPage: 1,
    limitNum: 10,
    offsetNum: 1,
    itemsRangeText: ''
  };
  const paginationStates = _objectSpread(_objectSpread({}, defaultPaginationProps), paginationStatesVal);
  const [currentPage, setCurrentPage] = (0, _react.useState)(paginationStates === null || paginationStates === void 0 ? void 0 : paginationStates.currentPage);
  const [limitNum, setLimitNum] = (0, _react.useState)(paginationStates === null || paginationStates === void 0 ? void 0 : paginationStates.limitNum);
  const [offsetNum, setOffsetNum] = (0, _react.useState)(paginationStates === null || paginationStates === void 0 ? void 0 : paginationStates.offsetNum);
  const [rangeText, setRangeText] = (0, _react.useState)(paginationStates === null || paginationStates === void 0 ? void 0 : paginationStates.itemsRangeText);
  const [disableNextBtn, setdisableNextBtn] = (0, _react.useState)(nextBtnDisable || false);
  const [disablePrevBtn, setdisablePrevBtn] = (0, _react.useState)(prevBtnDisable || true);
  //total pages based on limit; for eg if total item is 100 and limit or row is 20;
  //then total pages will be 110/20 = 5.5,
  //Math.ceil will round up to nearest higher number; so total pages will be 6
  const totalPages = Math.ceil(totalItems / limitNum);
  const onPageChange = () => {
    const endIndex = offsetNum + limitNum - 1 > totalItems ? totalItems : offsetNum + limitNum - 1;
    const rangeTextStr = "".concat(totalItems === 0 ? 0 : offsetNum, " - ").concat(endIndex, " of ").concat(totalItems); //text for range of items displayed per page; for eg(1-10 of 255)
    setRangeText(rangeTextStr);
    //sets prev btn disable state to true if first page; rest will be false
    setdisablePrevBtn(currentPage === 1);
    //sets next btn disable state to true if totalpage is 0 or current page is the last page; rest will be false
    setdisableNextBtn(totalPages === 0 || currentPage === totalPages);
    //callback or sets the parent state with property available for parent to use
    paginationStatesSetter({
      currentPage: currentPage,
      limitNum: limitNum,
      offsetNum: offsetNum,
      itemsRangeText: rangeTextStr,
      totalPages: totalPages
    });
  };
  const handlePrevious = () => {
    if (currentPage === 1) {
      // skips/disable prev btn click if no prevBtnDisable prop is passed from parent
      return;
    }
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
      setOffsetNum((currentPage - 1) * limitNum + 1 - limitNum);
    }
  };
  const handleNext = () => {
    if (currentPage === totalPages) {
      //skips/disable next btn click if no nextBtnDisable prop is passed from parent
      return;
    }
    if (currentPage < totalPages) {
      setCurrentPage(currentPage + 1);
      setOffsetNum(currentPage * limitNum + 1);
    }
  };
  const handleRowsChange = value => {
    setLimitNum(Number(value));
    setCurrentPage(1);
    setOffsetNum(1);
  };
  (0, _react.useEffect)(() => {
    //triggers only on page change or limit change
    onPageChange();
  }, [currentPage, limitNum]);
  (0, _react.useEffect)(() => {
    //triggers only when total item changes
    //reset current page and offset
    handleRowsChange(limitNum);
    //Callback to parent with updated states
    onPageChange();
  }, [totalItems]);
  return /*#__PURE__*/_react.default.createElement("div", {
    id: "svb-paginator",
    className: finalClasses
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "dropdown d-flex flex-row align-items-center"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "paginate-title mb-0 paragraph small"
  }, paginateTitle), /*#__PURE__*/_react.default.createElement("button", {
    className: "btn btn-secondary dropdown-toggle paragraph small",
    type: "button",
    "data-bs-toggle": "dropdown",
    "aria-expanded": "false"
  }, limitNum), /*#__PURE__*/_react.default.createElement("ul", {
    className: "dropdown-menu"
  }, rowsPerPageLists.map(rownum => /*#__PURE__*/_react.default.createElement("li", {
    key: rownum
  }, /*#__PURE__*/_react.default.createElement("a", {
    onClick: e => {
      e.preventDefault();
      handleRowsChange(rownum);
    },
    className: "dropdown-item",
    href: "#"
  }, rownum))))), /*#__PURE__*/_react.default.createElement("div", {
    className: "paginator-right-wrap d-flex align-self-center"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex px-3"
  }, /*#__PURE__*/_react.default.createElement("p", {
    className: "mb-0 d-flex align-items-center pr-10 paragraph small"
  }, rangeText)), /*#__PURE__*/_react.default.createElement("div", {
    className: "d-flex ps-1"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: "px-1"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "sams-list-icon ".concat(disablePrevBtn ? 'opacity-50 text-muted' : 'opacity-100'),
    src: _chevronLeft.default,
    alt: "previous icon",
    onClick: !disablePrevBtn ? handlePrevious : null,
    role: !disablePrevBtn ? 'button' : null
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: "ps-2 pe-0"
  }, /*#__PURE__*/_react.default.createElement("img", {
    className: "sams-list-icon ".concat(disableNextBtn ? 'opacity-50 text-muted' : 'opacity-100'),
    src: _chevronRight.default,
    alt: "next icon",
    onClick: !disableNextBtn ? handleNext : null,
    role: !disableNextBtn ? 'button' : null
  })))));
};
SVBPaginator.propTypes = {
  paginationStatesVal: _propTypes.default.shape({
    currentPage: _propTypes.default.number,
    totalPages: _propTypes.default.number,
    limitNum: _propTypes.default.number,
    offsetNum: _propTypes.default.number,
    itemsRangeText: _propTypes.default.string
  }),
  paginationStatesSetter: _propTypes.default.func.isRequired,
  totalItems: _propTypes.default.number.isRequired,
  nextBtnDisable: _propTypes.default.bool,
  prevBtnDisable: _propTypes.default.bool,
  rowsPerPageLists: _propTypes.default.array,
  overrideElementClass: _propTypes.default.string,
  extraClasses: _propTypes.default.string
};
var _default = exports.default = SVBPaginator;